export default __webpack_public_path__ + "static/media/100_51326.2e6dcdcc.jpg";